import { render } from "./ModalInputPopUp.vue?vue&type=template&id=a1537a96&scoped=true&ts=true"
import script from "./ModalInputPopUp.vue?vue&type=script&lang=ts"
export * from "./ModalInputPopUp.vue?vue&type=script&lang=ts"

import "./ModalInputPopUp.vue?vue&type=style&index=0&id=a1537a96&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1537a96"]])

export default __exports__